<template>
  <div>
    <p class="mb-4 title">Paiement par carte (CIB)</p>
    <v-card
        class="rounded-lg shadow"
        :loading="isLoading"
        :disabled="isLoading"
        elevation="0"
    >
      <v-card-text class="py-5 px-5">

        <v-switch hide-details
                  class="ma-0 pa-0 mb-5"
                  v-model="epayment_active"
                  color="blue"
                  label="Activation de Paiement par carte"
        ></v-switch>

        <v-btn block color="primary" large depressed class="rounded-lg" @click="changeEpaymentStatus">
          Enregistrer
        </v-btn>

      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import {HTTP} from "@/http-common";

export default {
  components: {},
  data() {
    return {
      isLoading: true,
      errors: {},
      epayment_active: false,
    };
  },
  methods: {
    fetchData() {
      console.log("Flexy");

      this.isLoading = true;
      HTTP.get("/v1/settings")
          .then((res) => {
            this.epayment_active = res.data.data.epayment.enabled;
            this.isLoading = false;

          })
          .catch((e) => {
            console.log(e);
            this.isLoading = false;
          });
    },
    changeEpaymentStatus() {
      this.isLoading = true;
      HTTP.post("/v1/settings/epayment_active", {
        e_payment : {
          enabled: this.epayment_active,
        }
      }).then(() => {
        this.isLoading = false;
        this.$successMessage = "Mise a jour avec succès";
      }).catch((e) => {
        this.isLoading = false;
      });
    }
  },
  mounted() {
    this.fetchData();
  },
};
</script>